import { Close } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Button,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Skeleton,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { DIALOG_MAX_WIDTHS } from "src/Components/Common/Modal/ModalWidth";

import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import useFetch from "src/Components/Common/useFetch";
import { API_ENDPOINTS } from "src/Utils/ApiConstants/ApiUrlConstants";
import { useVendorPortal } from "../VendorPortalLayout";

const VpRemarksDisputedEntries = ({ selectedRowOfDisputedEntryForModal, openRemarksModal, setOpenRemarksModal }) => {
  const [isListCommentLoading, setIsListCommentLoading] = useState(false);
  const { token } = useVendorPortal();
  const [remarks, setRemarks] = useState([]);

  const handleClose = () => {
    setOpenRemarksModal(false);
    setIsListCommentLoading(false);
  };

  useEffect(() => {
    getVpDrRemarkHistory(selectedRowOfDisputedEntryForModal?.gapId);
  }, []);

  const getVpDrRemarkHistory = async (gapId) => {
    await useFetch(API_ENDPOINTS.FETCH_VP_DR_ENTRIES_REMARK_HISTORY(gapId).url, "GET", {
      failureMessage: API_ENDPOINTS.FETCH_VP_DR_ENTRIES_REMARK_HISTORY(gapId).failureMessage,
      config: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
      thenCallBack: (response) => {
        setRemarks(response.data.data);
      },
      catchCallBack: () => {},
    });
  };
  const markAllReadRemarkHistory = async (gapId) => {
    await useFetch(API_ENDPOINTS.MARK_ALL_READ_VP_DR_ENTRIES_REMARK_HISTORY(gapId).url, "GET", {
      failureMessage: API_ENDPOINTS.MARK_ALL_READ_VP_DR_ENTRIES_REMARK_HISTORY(gapId).failureMessage,
      showSuccessToast: true,
      config: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
      thenCallBack: (_response) => {
        getVpDrRemarkHistory(gapId);
      },
      catchCallBack: () => {},
    });
  };
  const markReadRemarkHistory = async (remarkId) => {
    await useFetch(API_ENDPOINTS.MARK_READ_VP_DR_ENTRIES_REMARK_HISTORY(remarkId).url, "GET", {
      failureMessage: API_ENDPOINTS.MARK_READ_VP_DR_ENTRIES_REMARK_HISTORY(remarkId).failureMessage,
      showSuccessToast: true,
      config: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
      thenCallBack: (_response) => {
        getVpDrRemarkHistory(selectedRowOfDisputedEntryForModal?.gapId);
      },
      catchCallBack: () => {},
    });
  };

  return (
    <>
      <Dialog open={openRemarksModal} maxWidth={DIALOG_MAX_WIDTHS.SM} fullWidth>
        <DialogTitle className="dialog-title">
          <div className="heading-m">Remarks</div>
          <div className="vertical_center_align">
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent dividers sx={{ p: 2 }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "4px 0",
                marginBottom: "16px",
              }}
            >
              <Typography className="heading-xs">All Remarks</Typography>
              <Button
                startIcon={<RemoveRedEyeIcon />}
                className="heading-xs"
                sx={{
                  color: "#0288d1",
                  textTransform: "none",
                }}
                disabled={
                  remarks?.filter((remark) => !remark.is_viewed)?.length === 0
                  //   || isLoadingMarkInvoiceCommentAsRead
                }
                onClick={() => {
                  const unreadRemarkIds = remarks?.filter((remark) => !remark.is_viewed)?.map((remark) => remark.id);
                  if (unreadRemarkIds.length > 0) {
                    markAllReadRemarkHistory(selectedRowOfDisputedEntryForModal?.gapId);
                  }
                }}
              >
                Mark as read
              </Button>
            </Box>
            {/* Skeleton Loader */}
            {isListCommentLoading
              ? // Skeleton Loader
                Array.from({ length: 3 }).map((_, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "16px 0",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        gap: "8px",
                      }}
                    >
                      <Skeleton variant="circular" width={24} height={24} />
                    </Box>
                    <Box
                      sx={{
                        flex: 1,
                        marginLeft: "8px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <Skeleton variant="text" width="20%" height={20} />
                        <Skeleton variant="text" width="30%" height={20} />
                      </Box>
                      <Skeleton variant="text" width="80%" height={20} />
                    </Box>
                  </Box>
                ))
              : remarks?.map((remark) => (
                  <Box
                    key={remark.id}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "16px 0",
                      //   borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        // alignItems: 'center',
                        gap: "8px",
                      }}
                    >
                      <Avatar
                        sx={{
                          bgcolor: "#541c4c",
                          width: 24,
                          height: 24,
                          fontSize: 9.6,
                          fontWeight: 600,
                        }}
                      >
                        {remark?.userName
                          ?.split(" ")
                          ?.map((userName) => userName[0])
                          ?.join("")}
                      </Avatar>
                    </Box>
                    <Box
                      sx={{
                        flex: 1,
                        marginLeft: "8px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          //   marginBottom: '4px',
                        }}
                      >
                        <Typography className="heading-xs">{remark.userName}</Typography>
                        <Typography
                          className="body-s-medium"
                          sx={{
                            color: "rgba(0, 0, 0, 0.6)",
                          }}
                        >
                          {moment(remark.remarkedAt).format("MMMM D, YYYY [at] h:mm A")}
                        </Typography>
                        <Typography>
                          <Chip
                            size="small"
                            label={remark.department}
                            sx={{
                              fontSize: 12,
                            }}
                          />
                          {/* <Badge
                                badgeContent={remark.department}
                                color="primary"
                                sx={{
                                  "& .MuiBadge-badge": {
                                    padding: "0 4px",
                                    height: 20,
                                    borderRadius: 100,
                                    backgroundColor: "#e0e0e0",
                                    color: "#424242",
                                    fontSize: 12,
                                    fontWeight: 500,
                                    letterSpacing: 0.14,
                                    marginLeft: "8px",
                                  },
                                }}
                              >
                              </Badge> */}
                        </Typography>

                        {remark.isIssueRaised && (
                          <Box
                            sx={{
                              backgroundColor: "#d32f2f",
                              borderRadius: 100,
                              padding: "0 6.5px",
                              height: 20,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              sx={{
                                color: "#ffffff",
                                fontSize: 12,
                                fontWeight: 500,
                                letterSpacing: 0.14,
                              }}
                            >
                              Issue Raised
                            </Typography>
                          </Box>
                        )}
                      </Box>
                      <Typography className="body-s-medium">{remark.remark}</Typography>
                    </Box>
                    {!remark.is_viewed && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <IconButton
                          onClick={() => {
                            markReadRemarkHistory(remark.id);
                          }}
                          //   disabled={isLoadingMarkInvoiceCommentAsRead}
                        >
                          <RemoveRedEyeIcon />
                        </IconButton>
                      </Box>
                    )}
                  </Box>
                ))}
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default VpRemarksDisputedEntries;
